// extracted by mini-css-extract-plugin
export default {"container":"HeaderWithMenu_container__t9Y43","left":"HeaderWithMenu_left__MiBKZ","right":"HeaderWithMenu_right__eQiLN","title":"HeaderWithMenu_title__ILVEd"};